// extracted by mini-css-extract-plugin
export default {"roomsPage":"Rooms_roomsPage__j8gnp","pageTitle":"Rooms_pageTitle__66Brt","titleText":"Rooms_titleText__BORlS","titleLogo":"Rooms_titleLogo__J6i9E"};